import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { FaPaperPlane } from "react-icons/fa";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { BsDot, BsFillChatRightTextFill } from "react-icons/bs";
import { FaUser } from "react-icons/fa";
import { RxDotFilled } from "react-icons/rx";
import avatar from "../../assets/avatar.png";
import Aos from "aos";

const Chatbot = () => {
  const [showChat, setShowChat] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [chatLoaded, setChatLoaded] = useState(false);
  const [userMsg, setUserMsg] = useState(false);
  const [value, setValue] = React.useState("");
  const [msgHi, setMsgHi] = useState(false);
  const [support, setSupport] = useState(false);
  const [pricing, setPricing] = useState(false);
  const [contact, setContact] = useState(false);
  const [mail, setMail] = useState(false);
  const [mobile, setMobile] = useState(false);

  const bottomRef = useRef(null);
  const [toggleOption, setToggleOption] = useState(0);
  const optionBtn = (index) => {
    setToggleOption(index);
    msgLoader();
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const msgLoader = () => {
    setTimeout(() => {
      setChatLoaded(true);
    }, 1500);
    setChatLoaded(false);
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const [todos, setTodos] = React.useState([]);
  const addTodo = (text) => {
    const newTodos = [{ text }];
    setTodos(newTodos);
  };

  const userMsgLoader = () => {
    setTimeout(() => {
      setUserMsg(true);
    }, 1000);
    setUserMsg(false);
  };

  useEffect(() => {
    {
      todos.map((todo) => {
        if (
          todo.text === "hi" ||
          todo.text === "hii" ||
          todo.text === "hello" ||
          todo.text === "hiii" ||
          todo.text === "good morning" ||
          todo.text === "good afternoon" ||
          todo.text === "share the details"
        ) {
          setMsgHi(true);
          setMobile(false);
          setMail(false);
          bottomRef.current?.scrollIntoView({ behavior: "smooth" });
        }
        if (
          todo.text === "support" ||
          todo.text === "how can i contact you" ||
          todo.text === "how to get help" ||
          todo.text === "where to get help" ||
          todo.text === "how to get support"
        ) {
          setSupport(true);
          setPricing(false);
          setContact(false);
          setMsgHi(false);
          bottomRef.current?.scrollIntoView({ behavior: "smooth" });
        }
        if (todo.text === "pricing" || todo.text === "what are the pricing") {
          setPricing(true);
          setSupport(false);
          setContact(false);
          setMsgHi(false);
          bottomRef.current?.scrollIntoView({ behavior: "smooth" });
        }
        if (
          todo.text === "contact" ||
          todo.text === "how to contact" ||
          todo.text === "how i can contact" ||
          todo.text === "where i can discuss"
        ) {
          setContact(true);
          setSupport(false);
          setPricing(false);
          setMsgHi(false);
          bottomRef.current?.scrollIntoView({ behavior: "smooth" });
        }
        if (
          todo.text === "mail" ||
          todo.text === "can i get mail id" ||
          todo.text === "can i get email id" ||
          todo.text === "can i get email" ||
          todo.text === "can i get mail" ||
          todo.text === "email" ||
          todo.text === "emailId"
        ) {
          setMail(true);
          setMobile(false);
          // setContact(false);
          // setSupport(false);
          // setPricing(false);
          setMsgHi(false);
          bottomRef.current?.scrollIntoView({ behavior: "smooth" });
        }
        if (
          todo.text === "mobile no" ||
          todo.text === "mobile" ||
          todo.text === "can i get a contact no" ||
          todo.text === "can i get customer care no" ||
          todo.text === "can i get a mobile no" ||
          todo.text === "can i get a mobile" ||
          todo.text === "please share contact no" ||
          todo.text === "share a mobile no" ||
          todo.text === "share a contact no" ||
          todo.text === "share a contact number" ||
          todo.text === "share a mobile number" ||
          todo.text === "can i get mobile number" ||
          todo.text === "can i get contact number"
        ) {
          setMobile(true);
          setMail(false);
          // setContact(false);
          // setSupport(false);
          // setPricing(false);
          setMsgHi(false);
          bottomRef.current?.scrollIntoView({ behavior: "smooth" });
        }
        return <></>;
      });
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!value) return;
    addTodo(value);
    setValue("");
  };

  useEffect(() => {
    setTimeout(() => {
      setIsLoaded(true);
    }, 3000);
  }, []);

  useEffect(() => {
    Aos.init({ duration: 1200 });
  });

  return (
    <ChatbotContainer>
      {showChat === true ? (
        <ChatBox>
          <ChatBoxMain>
            <Header>
              <div className="data">
                <h4>Money Manager</h4>
                <p className="online">
                  <RxDotFilled className="dotIcon" /> Online
                </p>
              </div>
            </Header>
            <Border></Border>
            <ChatSection id="box">
              <div className="message">
                <div className="profile">
                  <img src={avatar} alt="" />
                </div>
                {isLoaded === true ? (
                  <div className="text">
                    Hi, I am MoneyBot how can i help you.
                  </div>
                ) : (
                  <div className="text">
                    <div className="dots">
                      <div class="container">
                        <div class="dot"></div>
                        <div class="dot"></div>
                        <div class="dot"></div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="impMsg">
                Use below options to know more about Money Manager
                <i className="fa-solid fa-arrow-turn-down"></i>
              </div>
              <div className="options">
                <div
                  className="optionName"
                  onClick={() => {
                    setSupport(true);
                    setPricing(false);
                    setContact(false);
                    msgLoader();
                  }}
                >
                  Support
                </div>
                <div
                  className="optionName"
                  onClick={() => {
                    setPricing(true);
                    setSupport(false);
                    setContact(false);
                    msgLoader();
                  }}
                >
                  Pricing
                </div>
                <div
                  className="optionName"
                  onClick={() => {
                    setContact(true);
                    setPricing(false);
                    setSupport(false);
                    msgLoader();
                  }}
                >
                  Contact Us
                </div>
              </div>
              {todos.map((todo, index) => (
                <div className="userMsg" key={index}>
                  {userMsg ? (
                    <div className="textUser">{todo.text}</div>
                  ) : (
                    <>
                      <div className="textUser">
                        <div className="dots">
                          <div class="container">
                            <div class="dot"></div>
                            <div class="dot"></div>
                            <div class="dot"></div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="profile">
                    <FaUser className="user" />
                  </div>
                </div>
              ))}
              {msgHi === true ? (
                <div className="message">
                  <div className="profile">
                    <img src={avatar} alt="" />
                  </div>
                  {chatLoaded ? (
                    <div className="text">Hello, how can i help you.</div>
                  ) : (
                    <div className="text">
                      <div className="dots">
                        <div class="container">
                          <div class="dot"></div>
                          <div class="dot"></div>
                          <div class="dot"></div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : null}
              {mail === true ? (
                <div className="message">
                  <div className="profile">
                    <img src={avatar} alt="" />
                  </div>
                  {chatLoaded ? (
                    <div className="text">
                      Here's the email to contact with money manager team <br />
                      <a href="mail:admin@moneymanagerindia.in">
                        admin@moneymanagerindia.in
                      </a>
                    </div>
                  ) : (
                    <div className="text">
                      <div className="dots">
                        <div class="container">
                          <div class="dot"></div>
                          <div class="dot"></div>
                          <div class="dot"></div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : null}
              {mobile === true ? (
                <div className="message">
                  <div className="profile">
                    <img src={avatar} alt="" />
                  </div>
                  {chatLoaded ? (
                    <div className="text">
                      Here's the mobile no to contact our money manager team{" "}
                      <br /> <a href="tel:+918888830536">+91 8888830536</a>
                    </div>
                  ) : (
                    <div className="text">
                      <div className="dots">
                        <div class="container">
                          <div class="dot"></div>
                          <div class="dot"></div>
                          <div class="dot"></div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : null}
              {support === true ? (
                <>
                  <div className="message">
                    <div className="profile">
                      <img src={avatar} alt="" />
                    </div>
                    {chatLoaded ? (
                      <div className="text">
                        Our team is always ready to resolve your problems.
                      </div>
                    ) : (
                      <div className="text">
                        <div className="dots">
                          <div class="container">
                            <div class="dot"></div>
                            <div class="dot"></div>
                            <div class="dot"></div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="msgInfo">
                    <div className="space-between">
                      <h3>24/7 Customer Support</h3>
                      <span
                        onClick={() => {
                          setSupport(false);
                        }}
                      >
                        <AiOutlineCloseCircle className="closeIco" />
                      </span>
                    </div>
                    <ul>
                      <li>
                        <BsDot className="dot" />
                        All time support
                      </li>
                      <li>
                        <BsDot className="dot" />
                        Software after-sales support
                      </li>
                      <li>
                        <BsDot className="dot" />
                        Long-term technical-support
                      </li>
                      <li>
                        <BsDot className="dot" />
                        Call On +91 8888830536
                      </li>
                    </ul>
                    <Link to="/support">
                      <div className="button">See Details</div>
                    </Link>
                  </div>
                </>
              ) : null}
              {pricing === true ? (
                <>
                  <div className="message">
                    <div className="profile">
                      <img src={avatar} alt="" />
                    </div>
                    {chatLoaded ? (
                      <div className="text">
                        Here are the details of pricing of the software.
                      </div>
                    ) : (
                      <div className="text">
                        <div className="dots">
                          <div class="container">
                            <div class="dot"></div>
                            <div class="dot"></div>
                            <div class="dot"></div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="msgInfo">
                    <div className="space-between">
                      <h3>Pricing</h3>
                      <span
                        onClick={() => {
                          setPricing(false);
                        }}
                      >
                        <AiOutlineCloseCircle className="closeIco" />
                      </span>
                    </div>
                    <p>Money manager has three plans</p>
                    <ul>
                      <li>
                        <BsDot className="dot" />
                        Free
                      </li>
                      <li>
                        <BsDot className="dot" />
                        Business
                      </li>
                      <li>
                        <BsDot className="dot" />
                        Enterprise
                      </li>
                    </ul>
                    <Link to="/pricing">
                      <div className="button">See Details</div>
                    </Link>
                  </div>
                </>
              ) : null}
              {contact === true ? (
                <>
                  <div className="message">
                    <div className="profile">
                      <img src={avatar} alt="" />
                    </div>
                    {chatLoaded ? (
                      <div className="text">
                        Here's the process to contact to our team.
                      </div>
                    ) : (
                      <div className="text">
                        <div className="dots">
                          <div class="container">
                            <div class="dot"></div>
                            <div class="dot"></div>
                            <div class="dot"></div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="msgInfo">
                    <div className="space-between">
                      <h3>Contact Us</h3>
                      <span
                        onClick={() => {
                          setContact(false);
                        }}
                      >
                        <AiOutlineCloseCircle className="closeIco" />
                      </span>
                    </div>
                    <p>
                      Our team is gracefully waiting for your queries & responce
                      of Money Manger software please fill the contact form we
                      will revert you back.
                    </p>
                    <Link to="/contact-us">
                      <div className="button">See Details</div>
                    </Link>
                  </div>
                </>
              ) : null}
              <div ref={bottomRef}></div>
            </ChatSection>
            <ChatInput>
              <input
                type="text"
                placeholder="Write your message here"
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
              <div
                onClick={() => {
                  msgLoader();
                  userMsgLoader();
                }}
              >
                <div className="arrowBtn" onClick={handleSubmit}>
                  <FaPaperPlane className="arrowIcon" />
                </div>
              </div>
            </ChatInput>
          </ChatBoxMain>
        </ChatBox>
      ) : null}
      <ChatBtn onClick={() => setShowChat(!showChat)}>
        <BsFillChatRightTextFill className="icon" />
      </ChatBtn>
    </ChatbotContainer>
  );
};

export default Chatbot;

const ChatbotContainer = styled.div`
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

const ChatBox = styled.div`
  position: fixed;
  top: 12%;
  right: 3%;
  z-index: 10000000;
  background-color: #fff;
  height: 490px;
  width: 310px;
  border-radius: 6px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);

  @media only screen and (max-width: 820px) {
    position: fixed;
    top: 48%;
    right: 3.5%;
  }
  @media only screen and (max-width: 768px) {
    position: fixed;
    top: 41.5%;
    right: 3.5%;
  }
  @media only screen and (max-width: 414px) {
    position: fixed;
    top: 35%;
    right: 4%;
  }
  @media only screen and (max-width: 393px) {
    position: fixed;
    top: 32%;
    right: 3.5%;
  }
  @media only screen and (max-width: 375px) {
    position: fixed;
    top: 16.7%;
    right: 3.5%;
  }
  @media only screen and (max-width: 360px) {
    position: fixed;
    top: 24%;
    right: 3.5%;
  }
`;

const ChatBoxMain = styled.div`
  position: relative;
  height: 100%;
`;

const ChatSection = styled.div`
  background-color: #fff;
  width: 100%;
  height: 80%;
  overflow: auto;
  padding: 6px 10px;
  margin-top: 7px;
  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: rgb(32, 32, 79);
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: rgb(32, 32, 79);
  }
  .impMsg {
    font-size: 13px;
    width: 100%;
    background-color: #ecebeb;
    color: green;
    padding: 8px 20px;
    border-radius: 25px;
    line-height: 17px;

    .fa-arrow-turn-down {
      color: green;
      font-size: 13px;
      margin-left: 5px;
    }
  }
  .userMsg {
    display: grid;
    grid-template-columns: 1fr 35px;
    grid-gap: 0.2rem;
    margin-bottom: 10px;
    .profile {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 35px;
      height: 35px;
      background-color: rgb(32, 32, 79);
      border-radius: 50%;
      cursor: pointer;
      margin-right: 7px;
      img {
        width: 17px;
        height: 17px;
      }
      .user {
        color: #fff;
      }
    }
    .textUser {
      position: relative;
      background-color: rgb(32, 32, 79);
      color: #fff;
      padding: 10px;
      line-height: 18px;
      border-radius: 4px;
      font-size: 14px;

      .dots {
        position: absolute;
        top: 5%;
      }
      .dot {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #fff;
        margin-right: 5px;
      }
      .container .dot:nth-last-child(1) {
        animation: jumpingAnimation 0.6s 0.1s ease-in infinite;
      }
      .container .dot:nth-last-child(2) {
        animation: jumpingAnimation 0.6s 0.2s ease-in infinite;
      }
      .container .dot:nth-last-child(3) {
        animation: jumpingAnimation 0.6s 0.3s ease-in infinite;
      }
      @keyframes jumpingAnimation {
        0% {
          transform: translate3d(0, 0, 0);
        }
        50% {
          transform: translate3d(0, 10px, 0);
        }
        100% {
          transform: translate3d(0, 0, 0);
        }
      }
    }
  }

  .message {
    display: grid;
    grid-template-columns: 35px 1fr;
    grid-gap: 0.2rem;
    margin-bottom: 10px;
    .profile {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 35px;
      height: 35px;
      background-color: rgb(58, 170, 53);
      border-radius: 50%;
      cursor: pointer;
      margin-right: 7px;
      img {
        width: 17px;
        height: 17px;
      }
    }
    .text {
      position: relative;
      background-color: rgb(58, 170, 53);
      color: #fff;
      padding: 10px;
      line-height: 18px;
      border-radius: 4px;
      font-size: 14px;

      a {
        text-decoration: underline;
        color: #fff;
      }

      .dots {
        position: absolute;
        top: 5%;
      }
      .dot {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #fff;
        margin-right: 5px;
      }
      .container .dot:nth-last-child(1) {
        animation: jumpingAnimation 0.6s 0.1s ease-in infinite;
      }
      .container .dot:nth-last-child(2) {
        animation: jumpingAnimation 0.6s 0.2s ease-in infinite;
      }
      .container .dot:nth-last-child(3) {
        animation: jumpingAnimation 0.6s 0.3s ease-in infinite;
      }
      @keyframes jumpingAnimation {
        0% {
          transform: translate3d(0, 0, 0);
        }
        50% {
          transform: translate3d(0, 10px, 0);
        }
        100% {
          transform: translate3d(0, 0, 0);
        }
      }
    }
  }

  .options {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-top: 15px;
    .optionName {
      padding: 4px 10px;
      border: 2px solid rgb(58, 170, 53);
      color: rgb(32, 32, 79);
      font-weight: 500;
      border-radius: 8px;
      margin-right: 8px;
      margin-bottom: 10px;
      cursor: pointer;
    }
  }
  .msgInfo {
    margin: 20px 0px;
    padding: 10px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
    font-size: 15px;
    font-weight: 500;
    color: rgb(32, 32, 79);

    .space-between {
      display: flex;
      align-items: center;
      justify-content: space-between;
      h3 {
        font-weight: 600;
        font-size: 20px;
        font-family: "Source Serif Pro", serif;
      }
      span {
        margin-top: -10px;
        margin-right: -7px;
        cursor: pointer;
        color: #666;

        .closeIco {
          font-size: 20px;
        }
      }
    }
    p {
      font-weight: 500;
      font-size: 15px;
    }
    ul {
      margin-top: 10px;
      li {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        list-style: none;
        font-size: 15px;
        font-weight: 500;
        margin-top: -5px;

        .dot {
          font-size: 30px;
          margin-right: -4px;
        }
      }
    }
    .button {
      padding: 3px 10px;
      background-color: rgb(58, 170, 53);
      width: 100%;
      color: #fff;
      text-align: center;
      border-radius: 5px;
      margin-top: 10px;
      cursor: pointer;
    }
  }
`;

const ChatInput = styled.form`
  position: absolute;
  bottom: 0%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  input {
    width: 255px;
    border: none;
    outline: none;
    padding: 12px 10px;
    border-top: 1px solid rgb(58, 170, 53);
  }
  .arrowBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 55px;
    height: 45px;
    background-color: rgb(58, 170, 53);
    cursor: pointer;
    margin-left: 0px;
    .arrowIcon {
      color: #fff;
      font-size: 20px;
    }
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 4px 10px;

  .profile {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    background-color: rgb(58, 170, 53);
    border-radius: 50%;
    cursor: pointer;
    margin-right: 10px;
    img {
      width: 20px;
      height: 20px;
    }
  }
  .data {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 5px;
    width: 100%;
    h4 {
      color: rgb(32, 32, 79);
      font-weight: 600;
      font-size: 14px;
      line-height: 11px;
    }
    .online {
      display: flex;
      align-items: center;
      justify-content: center;
      .dotIcon {
        color: green;
        font-size: 28px;
        margin-right: -4px;
      }
      color: green;
      font-weight: 500;
      font-size: 12px;
    }
    .offline {
      display: flex;
      align-items: center;
      justify-content: center;
      .dotIcon {
        color: red;
        font-size: 28px;
        margin-right: -4px;
      }
      color: red;
      font-weight: 500;
      font-size: 12px;
    }
  }
`;

const Border = styled.div`
  background-color: rgb(58, 170, 53);
  height: 1px;
  width: 100%;
`;

const ChatBtn = styled.div`
  position: fixed;
  top: 89%;
  right: 1.7%;
  z-index: 1000000000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: rgb(58, 170, 53);
  border-radius: 50%;
  cursor: pointer;

  .icon {
    font-size: 22.5px;
    color: #fff;
  }
`;
